import { combineReducers } from "redux";
import { FrameState } from "../../types";
import * as shared from "../shared";

/** The raw root reducer for the frame store. */
export const frame = combineReducers<FrameState>({
  ...shared,
});
